import React from 'react';
import Moment from 'moment';
import {orderHasMeaningfulUpdate} from './utils';

export default function OrderDetails({
  order,
  installmentData,
  totalPriceIncludingInstallments,
  hasInstallments,
}) {
  console.log('order666', order);
  const hasBeenUpdated = orderHasMeaningfulUpdate(order);
  return (
    <div className="col-md-4 client-details">
      <div className="client-info">
        <div className="card shadow-sm">
          <div className="card-header" style={{backgroundColor: '#404040', color: 'white'}}>
            Order Details
          </div>
          <div className="card-body p-0 pb-4">
            <br />
            <ul className="list-group list-group-flush order-details-list">
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Client Name:{' '}
                </strong>
                <span>
                  {/* <a target="_blank" rel="noreferrer" href={`/member/${order.memberId}`}> */}
                  {order.memberFirstName} {order.memberLastName}
                  {/* </a> */}
                </span>
              </li>
              <br />
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Branch:{' '}
                </strong>
                <span>
                  <i className="fa fa-map-marker"></i> {order.branchName}
                </span>
              </li>
              <br />
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Coach:{' '}
                </strong>
                <span>{order.trainerName}</span>
              </li>
              <br />
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;{order.isCamp === true ? 'Camp Title:' : 'Service Name:'}
                </strong>
                <span>{order.serviceName}</span>
              </li>
              <br />
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Package:
                </strong>
                <span>{order.packageLabel}</span>
              </li>
              <br />
              {installmentData?.length > 0 ? (
                <li
                  className="d-flex justify-content-between align-items-center"
                  style={{border: '0px none', padding: '8px 14px'}}
                >
                  <strong>
                    &nbsp;&nbsp;&nbsp;Price (Incl. Installments):
                  </strong>
                  <span>
                    <i className="fa fa-usd"></i> {Number(totalPriceIncludingInstallments).toFixed(2)}
                  </span>
                </li>
              ) : (
                <li
                  className="d-flex justify-content-between align-items-center"
                  style={{border: '0px none', padding: '8px 14px'}}
                >
                  <strong>
                    &nbsp;&nbsp;&nbsp;Total Order Price:
                  </strong>
                  <span>
                    <i className="fa fa-usd"></i> {Number(order.price).toFixed(2)}
                  </span>
                </li>
              )}
              <br />
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Package Price:
                </strong>
                <span>
                  <i className="fa fa-usd"></i>{' '}
                  {/* {(Number(order.price).toFixed(2) / order.quantity).toFixed(2)} */}
                  {Number(order.price).toFixed(2)}
                </span>
              </li>

              <br />
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Installment Payments:
                </strong>
                <span>{hasInstallments}</span>
              </li>
              <br />
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Quantity Ordered:
                </strong>
                <span>{order.quantity}</span>
              </li>
              <br />
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Remaining Credits on this Order:
                </strong>
                <span>
                  {order.current_remaining ?? 0}
                </span>
              </li>
              <br />
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;All Remaining Credits for this Service:
                </strong>
                <span>{order.remaining ?? 0}</span>
              </li>
              <br />
              {/* <li className="d-flex justify-content-left align-items-center" style={{ border: '0px none' }}>
                                <strong style={{ width: '270px', display: 'inline-block' }}>
                                    &nbsp;&nbsp;&nbsp;Credits in each Package:
                                </strong>
                                <span style={{ float: 'right', marginRight: '14px' }}>
                                    {order.pQ ?? 0}
                                </span>
                            </li>
                            <br />
                            <li className="d-flex justify-content-left align-items-center" style={{ border: '0px none' }}>
                                <strong style={{ width: '270px', display: 'inline-block' }}>
                                    &nbsp;&nbsp;&nbsp;Total Credits purchased in this Order:
                                </strong>
                                <span style={{ float: 'right', marginRight: '14px' }}>
                                    {updated_quantity ?? 0}
                                </span>
                            </li> */}
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Order Created:
                </strong>
                <span>
                  {Moment(order.createdAt?.date).format('MM-DD-YYYY h:mm A')}
                </span>
              </li>
              <br />
              {order?.byFrom && (
                <>
                  <li
                    className="d-flex justify-content-between align-items-center"
                    style={{border: '0px none', padding: '8px 14px'}}
                  >
                    <strong>
                      &nbsp;&nbsp;&nbsp;Order Placed By:
                    </strong>
                    <span>
                      {order?.byFrom.firstName + ' ' + order?.byFrom.lastName ?? ''}
                    </span>
                  </li>
                  <br />
                  <li
                    className="d-flex justify-content-between align-items-center"
                    style={{border: '0px none', padding: '8px 14px'}}
                  >
                    <strong>
                      &nbsp;&nbsp;&nbsp;Order Created In:
                    </strong>
                    <span>
                      {order?.byFrom.from === 'cop' && 'Coach Portal '}
                      {order?.byFrom.from === 'clp' && 'Client Portal'}
                      {order?.byFrom.from === 'hub' && 'Hub App'}
                      {order?.byFrom.from === 'ca' && 'Client App'}
                      {order?.byFrom.from === 'coa' && 'Client App Android'}
                    </span>
                  </li>
                  <br />
                </>
              )}
              <li
                className="d-flex justify-content-between align-items-center"
                style={{border: '0px none', padding: '8px 14px'}}
              >
                <strong>
                  &nbsp;&nbsp;&nbsp;Last Updated:
                </strong>
                <span>
                  {Moment(order.updatedAt?.date).format('MM-DD-YYYY h:mm A')}
                </span>
              </li>
              <br />
              {hasBeenUpdated && order.uName ? (
                <>
                  <li
                    className="d-flex justify-content-between align-items-center"
                    style={{border: '0px none', padding: '8px 14px'}}
                  >
                    <strong>
                      &nbsp;&nbsp;&nbsp;Last Updated By:
                    </strong>
                    <span>{order.uName}</span>
                  </li>
                  <br />
                </>
              ) : null}
              {/* {order.isCamp === true && order.individualClassId !== undefined && (
                <li
                  className="d-flex justify-content-left align-items-center"
                  style={{border: '0px none'}}
                >
                  <strong style={{width: '270px', display: 'inline-block', marginRight: '4px'}}>
                    &nbsp;&nbsp;&nbsp;Camp Report:
                  </strong>
                  <span style={{float: 'right', marginRight: '14px'}}>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={'/camp/camp-details/' + order.individualClassId}
                    >
                      Click Here
                    </a>
                  </span>
                </li>
              )} */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
